import { TOGGLE_ALERT_STATUS } from 'bento-ordering/base/actions/actionTypes';

/**
 * toggles the status of a specific alert.
 * alert argument should be one of the constants
 * from base/constants/orderAlerts. metaData is currently
 * used only for added menu item quantity
 */
export function toggleAlertStatus(alert, metaData = {}) {
  return { type: TOGGLE_ALERT_STATUS, payload: { alert, metaData } };
}
